import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import RedbookData from "./RedbookData";
// import redbook1 from '/images/archive/redbook_main.png';


const Redbook = () => {
    const [data, setData] = useState([]);
    const [visibleItems, setVisibleItems] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // 스크롤을 위한 ref (테이블 컨테이너에 적용)
    const scrollTableRef = useRef(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    // const slidesWrapperRef = useRef(null);
    // const slides = [
    //     redbook1
    // ];

    useEffect(() => {
        const fetchedData = RedbookData;
        setData(fetchedData);
        setVisibleItems(fetchedData.slice(0, 10));
        setCurrentIndex(10);
    }, []);

    const loadNextPage = useCallback(() => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);
        const newItems = data.slice(currentIndex, currentIndex + 10);
        setVisibleItems(prev => [...prev, ...newItems]);
        setCurrentIndex(prev => prev + 10);

        if (currentIndex + 10 >= data.length) {
            setHasMore(false);
        }

        setIsLoading(false);
    }, [data, currentIndex, isLoading, hasMore]);

    const handleScroll = useCallback(() => {
        const element = scrollTableRef.current;
        if (!element) return;

        const { scrollTop, clientHeight, scrollHeight } = element;
        if (scrollHeight - scrollTop - clientHeight <= 50) {
            loadNextPage();
        }
    }, [loadNextPage]);

    useEffect(() => {
        const scrollElement = scrollTableRef.current;
        if (scrollElement) {
            scrollElement.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (scrollElement) {
                scrollElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, [handleScroll]);

    // 자동 슬라이드 구현
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCurrentImageIndex((prevIndex) => (prevIndex + 1) % slides.length);
    //     }, 4000);

    //     return () => clearInterval(interval);
    // }, [slides.length]);

    // // currentImageIndex가 변경될 때마다 스타일 업데이트
    // useEffect(() => {
    //     if (slidesWrapperRef.current) {
    //         slidesWrapperRef.current.style.transition = `transform 400ms ease-in-out`;
    //         slidesWrapperRef.current.style.transform = `translateX(-${currentImageIndex * 100}%)`;
    //     }
    // }, [currentImageIndex]);


    return (
        <div id="container">
            <main id="contents">
                <div className="sub-content">
                    <div className="archive-wrap">
                        <div className="cont-top">
                            <div className="w-set">
                                <div className="title-wrap">
                                    <h2 className="title batang">조선총독부 직원록 중 <br className="hide-pc"/>학교 및 교원정보</h2>
                                    <p className="text">'직원록'은 정부 관료의 명단을 정리한 책입니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="cont-btm">
                            <div className="archive-text-box">
                                <div className="w-set">
                                    <div className="text-wrap">
                                        <p><strong>일제강점기 교원 정보를 어떻게 <br className="hide-pc" />찾을 수 있을까요?</strong></p>
                                        <p className="text">조선총독부는 조선 전체 직원에 대한 직원 명단을 정리하여 책으로 출간하였습니다. 그것이 바로 『조선총독부 직원록』(이하 『직원록』)입니다. 『직원록』에는 1910년에서 1943년까지 관공립학교에 근무했던 교원 정보가 있습니다.</p>
                                        <p className="text">우리는 『직원록』을 통해 교원 이름, 교원 소속, 관직, 관등(교원 등급), 공훈 등 교원 개인의 소속과 인적 사항을 확인하고, 이를 통해 교원이 어디서 어떠한 직위로 언제까지 근무했는지 알 수 있습니다.</p>
                                        <p className="text">또한 특정 학교의 직원 수 변화를 통해 학교의 규모 변화도 파악할 수 있습니다.</p>
                                    </div>
                                    <div className="img-wrap">
                                        <div className="archive-slides">
                                            <ul className="slides-wrapper">
                                                <li>
                                                    <div className="imgbox"><img src="/images/archive/redbook_main.png" alt="조선총독부 직원록(1910)" /></div>
                                                    <p className="caption">조선총독부 직원록(1910)</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="list-wrap">
                                <div className="w-set">
                                    <div className="list-top">
                                        <strong>조선총독부 직원록 목록</strong>
                                    </div>
                                    <div className="list-btm">
                                        <div className="table-wrap">
                                            <div className="scroll-table" ref={scrollTableRef}>
                                                {visibleItems.map((item, index) => (
                                                    <div className="list-row" key={index}>
                                                        <Link
                                                            to={`/archive/redbook/${item.book_id}`}
                                                            className="row-link"
                                                            key={item.book_id}
                                                        >
                                                            <div className="title">{item.book_title}</div>
                                                            <div className="title-ko bold c-black">{item.book_title_ko}</div>
                                                            <div className="year">{item.publish_year}</div>
                                                            <div className="date">{item.publish_date}</div>
                                                            <div className="publisher">{item.publisher}</div>
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {/* 로딩 인디케이터 */}
                                        <div className="load-wrap type-full" style={{ display: isLoading ? 'block' : 'none' }}>
                                            <div className="load-box">
                                                <div className="square"></div>
                                                <div className="square"></div>
                                                <div className="square"></div>
                                                <div className="square"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Redbook;